import Button from "../../Button";
import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import ResetSvgIcon from "../../../Svg/ResetSvgIcon";
import WebSocketHooks from "../../../Hooks/WebSocketHooks";
import ClipBoardSvgIcon from "../../../Svg/ClipBoardSvgIcon";
import ConnectPhoneHooks from "../../../Hooks/InstructionPage/ConnectPhoneHooks";

export default function ConnectPhone() {
  WebSocketHooks();

  const ConnectPhoneHks = ConnectPhoneHooks();

  const [copied, setIsCopied] = useState(false);

  useEffect(() => {
    ConnectPhoneHks.generateQR();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  }, [copied]);

  return (
    <div className="connectPhoneMainContainer">
      Connect Your Phone as Second Camera
      <p className="connectPhoneDesc">
        To ensure secure proctoring, use your phone to provide a side-angle
        view.
        <ol>
          <li>Scan the QR Code below using your phone.</li>
          <li>Grant Camera access when prompted.</li>
        </ol>
      </p>
      <div className="connectPhoneBody">
        <div className="connectPhoneBodyQRDiv">
          <div className="connectPhoneBodyQRHeader">
            <span className="connectPhoneBodyQRLabel">Scan QR Code</span>
            <ResetSvgIcon onClick={ConnectPhoneHks.generateQR} />
          </div>
          <QRCodeSVG
            size={192}
            className="qrCode"
            value={ConnectPhoneHks.QRDetail.url}
          />
        </div>
        <span>(or)</span>
        <div className="connectPhoneBodyURL">
          <span className="connectPhoneBodyURLLabel">Visit this page:</span>
          <div className="connectPhoneBodyURLInputDiv">
            <input
              readOnly
              type="text"
              onClick={(e) => e.target.select()}
              value={ConnectPhoneHks.QRDetail.url}
              className="connectPhoneBodyURLInput"
            />
            {copied ? (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="17"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#f04438"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </>
            ) : (
              <ClipBoardSvgIcon
                onClick={() => {
                  setIsCopied(true);
                  navigator.clipboard.writeText(ConnectPhoneHks.QRDetail.url);
                }}
              />
            )}
          </div>
        </div>
      </div>
      <div className="connectPhoneBtn">
        <Button
          size="sm"
          onClick={ConnectPhoneHks.validateToken}
          hierarchy={{
            type: "primary",
            buttonText: "Set Camera View",
          }}
        />
      </div>
    </div>
  );
}
